export default __webpack_public_path__ + "static/media/XEMP-5.21150142.jpg";